import { useSidebarSession } from '../bridge/session';
import {
  AlertIcon,
  CheckIcon,
  ChevronRightIcon,
  ContinuousPasteIcon,
  PasteIcon
} from '../components/Icons';
import { bucketInitial, pluralize } from './presentation';
import { usePaste } from './paste';

export function PasteDock() {
  const { snapshot } = useSidebarSession();
  const paste = usePaste();
  const activeLabel = snapshot.activeBucket?.label ?? null;
  const pageNumber = Math.max(1, snapshot.pageSession.continuous?.stepCount ?? 1);

  return (
    <footer className="paste-dock">
      {!paste.continuous && paste.confirmation?.kind === 'pasted' && (
        <div className="paste-confirmation" role="status">
          <CheckIcon />
          <span>
            Filled {paste.confirmation.count} {pluralize(paste.confirmation.count, 'field')} from{' '}
            {paste.confirmation.bucketLabel}
          </span>
        </div>
      )}
      {!paste.continuous && paste.confirmation?.kind === 'outcome' && (
        <div className="paste-confirmation paste-confirmation--info" role="status">
          <AlertIcon />
          <span>{paste.confirmation.message}</span>
        </div>
      )}

      {paste.continuous && (
        <div className="continuous-status" role="status">
          <div className="continuous-status__top">
            <span className="continuous-bars" aria-hidden="true">
              <span />
              <span />
              <span />
            </span>
            <strong>Continuous fill</strong>
            <span className="continuous-status__page">
              Page {pageNumber}
              {snapshot.pageSession.continuous?.status === 'PAUSED' && ' · Paused'}
            </span>
          </div>
        </div>
      )}

      {paste.notice && (
        <div className="paste-confirmation" role="status">
          <CheckIcon />
          <span>{paste.notice}</span>
        </div>
      )}

      {paste.error && (
        <button type="button" className="dock-error" title="Dismiss" onClick={paste.clearError}>
          {paste.error.message}
        </button>
      )}

      {!paste.continuous ? (
        <div className="paste-dock__buttons">
          <button
            type="button"
            className="dock-button dock-button--continuous"
            disabled={!paste.canPaste}
            aria-busy={paste.busy === 'start-continuous'}
            onClick={() => void paste.startContinuous()}
          >
            <ContinuousPasteIcon />
            <span>Continuous fill</span>
          </button>
          <button
            type="button"
            className="dock-button dock-button--primary"
            disabled={!paste.canPaste}
            aria-busy={paste.busy === 'once'}
            onClick={() => void paste.pasteOnce()}
          >
            <PasteIcon />
            <span>Fill page</span>
            <span className="bucket-chip" aria-label={activeLabel ?? 'No active bucket'}>
              {bucketInitial(activeLabel)}
            </span>
          </button>
        </div>
      ) : (
        <div className="paste-dock__buttons">
          <button
            type="button"
            className="dock-button dock-button--primary"
            disabled={paste.busy !== null}
            aria-busy={paste.busy === 'continue'}
            onClick={() => void paste.continueContinuous()}
          >
            <span>Fill this page now</span>
            <ChevronRightIcon />
          </button>
          <button
            type="button"
            className="dock-button dock-button--continuous"
            disabled={paste.busy !== null}
            aria-busy={paste.busy === 'finish'}
            onClick={() => void paste.finishContinuous()}
          >
            <span>Done</span>
          </button>
        </div>
      )}

      <p className="paste-dock__principle">You review and submit — Cara never submits for you.</p>
    </footer>
  );
}
